import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
// import App from './layouts/App'; // 舊版本
import ElderlyApp from './layouts/ElderlyApp'; // 新的老人版
import ErrorBoundary from './components/ErrorBoundary';

// 全域錯誤處理
window.addEventListener('error', (event) => {
  console.error('全域 JavaScript 錯誤:', event.error);
  console.error('錯誤來源:', event.filename, '行數:', event.lineno);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('未處理的 Promise 拒絕:', event.reason);
  // 防止預設的錯誤處理行為
  event.preventDefault();
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('找不到 root 元素，無法啟動應用');
}

const root = createRoot(container);

// 使用 try-catch 來捕獲渲染錯誤
try {
  root.render(
    <ErrorBoundary>
      <ElderlyApp />
    </ErrorBoundary>
  );
} catch (error) {
  console.error('應用渲染失敗:', error);
  
  // 如果主應用無法啟動，顯示簡單的錯誤頁面
  container.innerHTML = `
    <div style="
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      background-color: #f5f5f5;
    ">
      <div style="
        max-width: 500px;
        padding: 2rem;
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        text-align: center;
      ">
        <h1 style="color: #d32f2f; margin-bottom: 1rem;">應用啟動失敗</h1>
        <p style="color: #666; line-height: 1.6; margin-bottom: 1.5rem;">
          抱歉，應用無法正常啟動。請嘗試以下解決方案：<br/>
          1. 刷新頁面<br/>
          2. 清除瀏覽器緩存<br/>
          3. 聯繫技術支援
        </p>
        <button 
          onclick="window.location.reload()" 
          style="
            background: #1976d2;
            color: white;
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 4px;
            cursor: pointer;
            font-size: 1rem;
          "
        >
          刷新頁面
        </button>
      </div>
    </div>
  `;
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
